module.exports = __webpack_public_path__ + "06e18312dc1317266dc5c81f52837617.png";